/** ------------------- GENERAL ---------------------------------- */

export const SET_AUTH_INFO = "SET AUTH INFO";
